import { AwsRum } from 'aws-rum-web';

let awsRum: any = null;

export function initializeAWSRum(rumUIParams: any) {
  try {
    const { APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config } =
      rumUIParams;
    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );
  } catch (error) {
    // Rum initialisation is failed
  }
  return awsRum;
}

export async function getAWSRumInstance(rumUIParams?: any) {
  if (awsRum) {
    return awsRum;
  }
  if (rumUIParams) {
    awsRum = initializeAWSRum(rumUIParams);
  }

  return awsRum;
}

export function recordErrorInCloudWatchRUM(message: string) {
  getAWSRumInstance().then((awsRum) => {
    if (awsRum) {
      awsRum.recordError?.(message);
    }
  });
}

export function recordCustomEventInCloudWatchRUM(
  eventName: string,
  eventProperties: any
) {
  getAWSRumInstance().then((awsRum) => {
    if (awsRum) {
      awsRum?.recordEvent?.(eventName, {
        view_properties: {
          page: window.location.pathname,
        },
        ...eventProperties,
      });
    }
  });
}

export function setCustomSessionProperties(
  customSessionProperties: any,
  rumUIParams?: any
) {
  getAWSRumInstance(rumUIParams).then((awsRum) => {
    if (awsRum) {
      awsRum.addSessionAttributes?.(customSessionProperties);
    }
  });
}

export default getAWSRumInstance;
